import { useEffect, useMemo, useRef } from 'react';
import { useInventoryAppServices } from '@/app/services/InventoryAppServicesContext';
import type { CaptureSession } from '@/shared/capture/capture-session';

export function useInventorizationActivityTimer(session: CaptureSession | null | undefined) {
  const services = useInventoryAppServices();
  const repositories = useMemo(
    () => ({
      captureSessions: services.captureSessions,
    }),
    [services.captureSessions],
  );
  const sessionRef = useRef(session);
  const sessionId = session?.id;

  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  useEffect(() => {
    const activeSession = sessionRef.current;

    if (!(activeSession && sessionId)) {
      return undefined;
    }

    const startedAt = Date.now();

    return () => {
      const durationMs = Date.now() - startedAt;

      void repositories.captureSessions.update(sessionId, session => ({
        ...session,
        data: {
          ...session.data,
          timeSpentMs: ((session.data.timeSpentMs as number | undefined) ?? 0) + durationMs,
        },
        updatedAt: new Date().toISOString(),
      }));
    };
  }, [repositories, sessionId]);
}
